export const config = {
	apiKey: "AIzaSyCiPQ6pOCPE1-ExcjkH2gdOVCgKznVAj1A",
	authDomain: "swipe-app-wenum-wiesel.firebaseapp.com",
	projectId: "swipe-app-wenum-wiesel",
	storageBucket: "swipe-app-wenum-wiesel.firebasestorage.app",
	messagingSenderId: "511522023825",
	appId: "1:511522023825:web:c3834b77ad140323c0d230",
};
